import styled from "styled-components";

export const DeliveryOrderPickerModalWrapper = styled.div`
  padding: 1.5rem;
  min-width: 320px;
  max-width: 480px;

  h3 {
    margin: 0 0 1rem;
    font-size: 1.125rem;
    font-weight: 600;
  }

  .order-list {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    max-height: 360px;
    overflow-y: auto;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  .order-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 0.25rem;
    width: 100%;
    padding: 0.75rem;
    border: 1px solid var(--color-border, #e5e7eb);
    border-radius: 0.5rem;
    background: #fff;
    cursor: pointer;
    text-align: left;
    transition: border-color 0.15s ease, background 0.15s ease;

    &:hover {
      border-color: var(--color-primary, #6366f1);
      background: var(--color-primary-light, #eef2ff);
    }
  }

  .order-id {
    font-weight: 600;
    font-size: 0.875rem;
  }

  .order-customer {
    font-size: 0.875rem;
    color: var(--color-text-primary, #24272e);
  }

  .order-city {
    font-size: 0.75rem;
    color: var(--color-text-secondary, #6b7280);
  }

  .empty-text,
  .error-text {
    font-size: 0.875rem;
    color: var(--color-text-secondary, #6b7280);
    margin: 0;
  }

  .error-text {
    color: var(--color-error, #dc2626);
  }

  .link-button {
    background: none;
    border: none;
    padding: 0;
    color: var(--color-primary, #6366f1);
    cursor: pointer;
    font-size: inherit;
    text-decoration: underline;
  }
`;
